import Slideshow from "../../classes/Slideshow";
import {updateNumbers} from "./updateNumbers";
import {trigger} from "../../../utils/events/trigger";

export const initArticleCard = () => {
	const components = Array.from(document.querySelectorAll(`article.card`));
	
	if ( components.length )
	{
		components.forEach( (component) => {
			const favouritesButton = component.querySelector(`button.favourites`);
			const inputFinishing = component.querySelector(`input#apartment-finishing`);
			const slider = component.querySelector(`div.slideshow`);
			const slidesContainer = slider.querySelector(`ul.slides`);
			const navsContainer = component.querySelector(`div.layout ul.bookmarks`);
			const compass = component.querySelector(`div.compass`);
			
			if ( compass )
			{
				const angle = compass.dataset.windrose;
				
				compass.style = `transform: rotate(${angle}deg); transform-origin: center; transform-box:fill-box;`;
				
				if ( navsContainer )
				{
					navsContainer.childNodes.forEach( ( item, index ) => {
						const status = ( index === 2 || item.classList.contains( 'video' ) ) ? `none` : `block`;
						
						item.addEventListener( `click`, () => {
							compass.style.display = status;
						} );
					} )
				}
			}

			if ( slidesContainer )
			{
				const floorLayout = slidesContainer.querySelector(`li.floor svg`);
				
				if ( floorLayout )
				{
					const positionOnFloor = floorLayout.closest(`li`).getAttribute(`data-position-on-floor`);
					const layouts = [floorLayout.querySelector(`svg #APT-${positionOnFloor}`), floorLayout.querySelector(`svg #CMR-${positionOnFloor}`)];

					layouts.forEach((layout) => {
						if( layout ) 
						{
							layout.setAttribute(`data-enabled`, ``);
							layout.setAttribute(`data-title`, component.querySelector(`h1`).textContent);
						}
					});
				}
			}

			if ( slidesContainer && navsContainer )
			{
				new Slideshow({
					slidesContainer,
					navsContainer,
				});
			}
			
			if ( favouritesButton )
			{
				favouritesButton.addEventListener(`click`, () => favouritesButton.classList.toggle(`favourites--added`));
			}
			
			if ( inputFinishing )
			{
				const calcPriceInput = document.querySelector(`section.calculator-mortgage [name="price"]`);
				const apartmentPrice = component.querySelector(`div.info div.price strong`);
				const apartmentOldPrice = component.querySelector(`div.info div.price ul li.price--old`);
				const ajaxFormButton = component.querySelector(`button.get-ajax-form`);
				/*const apartmentPayment = component.querySelector(`div.info div.price ul li.price--mortgage`);*/
				let animationId;

				inputFinishing.addEventListener(`change`, () => {
					const price = +apartmentPrice.getAttribute(`data-main`);
					const oldPrice = apartmentOldPrice ? +apartmentOldPrice.getAttribute(`data-main`) : null;

					const finishingPrice = apartmentOldPrice ? +inputFinishing.getAttribute(`data-sale-finishing`) : +inputFinishing.getAttribute(`data-main-finishing`);
					const finishingOldPrice = +inputFinishing.getAttribute(`data-main-finishing`);

					// const prevPayment = +apartmentPayment.textContent.replace(/\D/g, ``);
					// const nextPayment = +apartmentPayment.getAttribute(`data-mortgage`);
					// const payment = +apartmentPayment.getAttribute(`data-mortgage`);
					// const finishingPayment = apartmentOldPrice ? +inputFinishing.getAttribute(`data-sale-finishing-mortgage`) : +inputFinishing.getAttribute(`data-main-finishing-mortgage`);

					cancelAnimationFrame(animationId);

					if ( inputFinishing.checked )
					{
						if ( calcPriceInput )
						{
							calcPriceInput.value = finishingPrice;
							trigger(calcPriceInput, `change`);
							setApartmentFinishingStatus(ajaxFormButton, `yes`);
						}
						
						updateNumbers(animationId, 200, {startValue: price, endValue: finishingPrice, container: apartmentPrice}, {startValue: oldPrice, endValue: finishingOldPrice, container: apartmentOldPrice}/*, {startValue: prevPayment, endValue: nextPayment, container: apartmentPayment}*/);
					} else
					{
						if ( calcPriceInput )
						{
							calcPriceInput.value = price;
							trigger(calcPriceInput, `change`);
							setApartmentFinishingStatus(ajaxFormButton, `no`);
						}
						
						updateNumbers(animationId, 200, {startValue: finishingPrice, endValue: price, container: apartmentPrice}, {startValue: finishingOldPrice, endValue: oldPrice, container: apartmentOldPrice}/*, {startValue: prevPayment, endValue: nextPayment, container: apartmentPayment}*/);
					}
				});
			}
		});
	}
};

const setApartmentFinishingStatus = (ajaxFormButton, status) => {
	ajaxFormButton.dataset.names = JSON.stringify({
		...JSON.parse(ajaxFormButton.dataset.names),
		...{apartment_finishing: status}
	});
}
